/**
 * Created by zhengyongbo on 17/8/21.
 */
import * as types from '../mutation-types'

const namespaced=true;
// initial state
const state = {
  name:'page test',
  all: []
}

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {

}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
